import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { employeesKeys } from 'src/features/employees/api/query-keys/employees';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { deleteEmployee } from '../../api/lib/employees';

export const useDeleteEmployee = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (employeeToken: string) => deleteEmployee(employeeToken),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: employeesKeys.lists(),
        });
      });
      toast.success(t('employees:employees.deleteEmployeeDialog.success'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
